import {
  List, Loader, Spinner, Table,
} from '@oliasoft-open-source/react-ui-library';
import cx from 'classnames';
import { useTranslation } from 'react-i18next';
import translations from 'client/internationalization/translation-map.json';

import { RootState } from 'client/store/configureStore';
import { getUserUnitsTemplatesData } from 'client/store/entities/unit-templates/unit-templates';
import { ConnectedProps, connect } from 'react-redux';
import styles from '../user-settings.module.css';

const UnitSettings = ({
  configuration,
  isLoading,
}: PropsFromRedux) => {
  const { t } = useTranslation();

  const tableRows = configuration?.map(({ quantity, unit }) => {
    return {
      cells: [{ value: quantity }, { value: unit }],
    };
  });

  const tableData = {
    headers: [
      {
        cells: [{ value: t(translations.settings_quantity) }, { value: t(translations.settings_unit) }],
      },
    ],
    rows: tableRows,
  };

  const listOptions = {
    name: t(translations.settings_unitTemplates),
    actions: [
    ],
    items: [],
  };

  return (
    <div className={styles.appearanceWrapper}>
      <div className={styles.sidebar}>
        <List list={listOptions} />
      </div>
      <div className={cx(styles.tabContent, styles.widthFull)}>
        {isLoading ? (
          <Loader height="200px" theme="light">
            <Spinner dark />
          </Loader>
        ) : <Table table={tableData} />}
      </div>
    </div>
  );
};

const mapStateToProps = ({ entities }: RootState) => ({
  isLoading: entities.unitTemplates?.isLoading,
  configuration: entities.unitTemplates.configuration,
  customer: entities.customer.selectedCustomer,
});

const mapDispatchToProps = {
  getUserUnitsTemplatesData,
};

const connector = connect(mapStateToProps, mapDispatchToProps);

type PropsFromRedux = ConnectedProps<typeof connector>;

const Container = connector(UnitSettings);

export { Container as UnitSettings };
